import React, {useReducer} from 'react';


const initialState = {
    isOpen: false,
    pulseTitle: false,
    currentStep: 0
}

function reducer(state, action) {
    switch (action.type) {
        case 'OPEN':
            return {
                ...state,
                isOpen: true
            }
        case 'CLOSE':
            return {
                ...state,
                isOpen: false,
                pulseTitle: false,
                currentStep: 0
            }

        case 'PULSE':
            return {
                ...state,
                pulseTitle: !state.pulseTitle
            }
        case 'NEXT_STEP':
            return {
                ...state,
                currentStep: state.currentStep + 1
            }
        case 'PREVIOUS_STEP':
            return {
                ...state,
                currentStep: state.currentStep - 1
            }
        default:
            return false;
    }
}

export const TourContext = React.createContext({});

export const TourProvider = ({children}) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <TourContext.Provider value={{state, dispatch}}>
            {children}
        </TourContext.Provider>
    )


}